import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import CircularProgress from '@material-ui/core/CircularProgress';

import IconEmail from '@material-ui/icons/Email';
import IconVpnKey from '@material-ui/icons/VpnKey';

import commonStyles from '../common/Styles';
import ButtonLink from '../common/ButtonLink';
import IcoTextField from '../common/IcoTextField';

import FacebookLogin from '../FacebookLogin/index';
import GoogleAppLogin from '../GoogleAppLogin/GoogleAppLogin';
// eslint-disable-next-line
const emailRegexp = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const styles = (theme) => ({
  header: {
    fontSize: 24,
    lineHeight: '32px',
    textAlign: 'left',
    fontWeight: 400,
    marginTop: 0,
    paddingTop: 12,
  },
  form: commonStyles(theme).form,
  actionButtons: commonStyles(theme).actionButtons,
});

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      usernameInvalid: true,
      passwordInvalid: true,
      username: '',
      password: '',
      usernameError: '',
      passwordError: '',
    };
    this.updateState = ({ target: { name, value } }) => {
      this.setState({ [name]: value, autofilled: false }, () => this.validate(name));
    };
    this.handleBlur = (event) => {
      event.persist();
      const { target: { name }} = event;
      this.setState({  [`${name}Touched`]: true }, () => this.updateState(event));
    };
    this.progressHandler = () => {
        this.setState({inProgress: true});
    };
    this.progressStopHandler = () => {
        this.setState({inProgress: false});
    };
    this.redirectHandler = (data) => {
        this.props.onLogin(data);
    };
    this.login = (event) => {
      const { username, password } = this.state;
      if (!this.validate() || this.state.inProgress) {
        return;
      }
      this.setState({ inProgress: true });
      event.preventDefault();
      window.AvaCAS.login({ username, password })
        .then(
          (data) => {
            this.setState({ inProgress: false });
            this.props.onLogin(data, this.state.username);
          },
          (error) => {
            this.setState({
              inProgress: false,
              loginError: 'Login attempt failed, are the username and password correct?',
            }, () => {
//              this.refs.passwordField.focus();
            });
          }
        );
    };
    this.validate = (field = 'both') => {
      let { usernameInvalid, passwordInvalid, usernameTouched, passwordTouched } = this.state;
      if (field !== 'password') {
        usernameInvalid = !emailRegexp.test(this.state.username) && usernameTouched && this.state.username;
        const usernameError = usernameInvalid ? 'Username must be a valid e-mail address' : '';
        this.setState({ usernameInvalid, usernameError });
      }
      if (field !== 'username') {
        passwordInvalid = (this.state.password || '').length < 8 && passwordTouched && this.state.password;
        const passwordError = passwordInvalid ? 'Password must have at least 8 characters' : '';
        this.setState({ passwordInvalid, passwordError });
      }
      return !usernameInvalid && !passwordInvalid;
    };

    if (props.isCordova) {
      setTimeout(()=> {
        this.setState({ username: localStorage.getItem('last_username') });
      });
    }

    this.checkIfAutofilledCounter = 0;
    this.checkIfAutofilled();
  }
  checkIfAutofilled() {
    this.checkIfAutofilledCounter++;
    setTimeout(() => {
      try {
        if (document.querySelector('#password:-webkit-autofill')) {
          this.setState({ autofilled: true });
        } else if (this.checkIfAutofilledCounter <= 20) {
          this.checkIfAutofilled();
        }
      } catch(e) {}
    }, 100);
  }
  isContinueDisabled() {
    if (this.state.autofilled) {
      return false;
    }
    return !!(this.state.usernameInvalid || !this.state.username || this.state.passwordInvalid || !this.state.password || this.state.inProgress);
  }
  onThemeChange = this.props.onThemeChange
  render() {
    const { classes } = this.props;
    return (
      <div
        className="Login">
        <form
          className={classes.form}>
          <h2
            className={classes.header}>Sign in</h2>
          <IcoTextField
            autoFocus
            icon={IconEmail}
            required
            id="username"
            name="username"
            label="Username"
            value={this.state.username}
            type="email"
            margin="normal"
            helperText={this.state.usernameError}
            onBlur={this.handleBlur}
            onChange={this.updateState}
            error={this.state.usernameInvalid && this.state.usernameTouched}
            onKeyDown={(event) => event.key === 'Enter' ? this.login(event) : null }></IcoTextField>
          <IcoTextField
            ref="passwordField"
            icon={IconVpnKey}
            required
            id="password"
            name="password"
            label="Password"
            type="password"
            value={this.state.password}
            margin="normal"
            helperText={this.state.passwordError}
            onBlur={this.handleBlur}
            onChange={this.updateState}
            error={this.state.passwordInvalid && this.state.passwordTouched}
            onKeyDown={(event) => event.key === 'Enter' ? this.login(event) : null }></IcoTextField>
          {this.state.loginError && <p className="login-error">{this.state.loginError}</p>}
          <div
            className={classes.actionButtons}>
            <ButtonLink
              tabIndex="-1"
              disabled={ !!this.state.inProgress }
              to="/recover">Forgot password?</ButtonLink>
            <span>
              { this.state.inProgress && <CircularProgress className="in-progress" size={32} /> }
              <Button
                color="secondary"
                variant="contained"
                disabled={this.isContinueDisabled()}
                onClick={this.login}>Continue</Button>
            </span>
          </div>
        </form>
        <Divider />
        { this.props.facebookAppId && <div style={{ marginTop: 24, textAlign: 'center'}}><FacebookLogin register={false} facebookAppId={this.props.facebookAppId} progressHandler={this.progressHandler} progressStopHandler={this.progressStopHandler} redirectHandler={this.redirectHandler}/></div>}
        { this.props.googleAppId && <div style={{ marginTop: 24, textAlign: 'center'}}><GoogleAppLogin register={false} googleAppId={this.props.googleAppId} progressHandler={this.progressHandler} progressStopHandler={this.progressStopHandler} redirectHandler={this.redirectHandler}/></div>}
        { this.props.allowCreate && (
        <div style={{ marginTop: 24, textAlign: 'center' }}>
          <ButtonLink
            to="/register">Create new account</ButtonLink>
        </div> ) }
      </div>
    );
  }
}

export default withStyles(styles)(Login)



// WEBPACK FOOTER //
// ./src/components/Login/Login.js